import { SlideComponentDnd } from '@/types/slide';
import { SlideComponentCreator } from './factory';

export class SlideComponentDndCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentDnd {
        return {
            id: id,
            pos: {
                x: 0,
                y: 0,
            },
            size: {
                width: 1024,
                height: 768,
            },
            type: 'dnd',
            content: {
                settings: {
                    reusable: false,
                },
                dragZone: [
                    {
                        id: crypto.randomUUID(),
                        type: 'default',
                        pos: {
                            x: 412,
                            y: 156,
                        },
                        size: {
                            width: 200,
                            height: 200,
                        },
                        settings: {
                            backgroundColor: '#DADEE7',
                        },
                        tag: '',
                    },
                ],
                dropZone: [
                    {
                        id: crypto.randomUUID(),
                        type: 'default',
                        pos: {
                            x: 412,
                            y: 462,
                        },
                        size: {
                            width: 200,
                            height: 200,
                        },
                        settings: {
                            backgroundColor: '#DADEE7',
                            multiple: true,
                        },
                        tag: '',
                        connectIds: [],
                    },
                ],
            },
        };
    }
}
